/**
 * FairwayBid – feste Bilder je Kategorie
 *
 * Anfragen haben kein Produktfoto: Ein Golfclub, der eine Ballwaschmaschine
 * sucht, hat keine. Statt einer leeren Karte zeigt FairwayBid deshalb ein
 * festes Bild je Kategorie.
 *
 * Bild austauschen: Datei in public/static/categories/ ersetzen, gleicher Name.
 * Neue Kategorie: Bild ablegen und unten in CATEGORY_IMAGES eintragen.
 * Die Kategorie-IDs stehen in der Console unter Listings -> Listing categories.
 */

// Ordner, in dem die Bilder liegen (unterhalb von public/)
const BASE = '/static/categories';

// Feldnamen, unter denen die Kategorie in publicData stehen kann.
// Sharetribe legt verschachtelte Kategorien als categoryLevel1..3 ab.
const CATEGORY_KEYS = ['categoryLevel1', 'categoryLevel2', 'category'];

/**
 * Kategorie-ID -> Bilddatei.
 * Fehlt eine Kategorie hier, greift DEFAULT_IMAGE.
 */
export const CATEGORY_IMAGES = {
  'range-golfballs-listing-type': `${BASE}/range-golfballs.png`,
  ballautomaten: `${BASE}/ballautomaten.png`,
  ballwaschmaschinen: `${BASE}/ballwaschmaschinen.png`,
  ballsammler: `${BASE}/ballsammler.png`,
  'range-matten': `${BASE}/range-matten.png`,
  pflegetechnik: `${BASE}/pflegetechnik.png`,
  'netze-systeme': `${BASE}/netze-systeme.png`,
  'golf-carts': `${BASE}/golf-carts.png`,
  ersatzteile: `${BASE}/ersatzteile.png`,
  gebrauchtmaschinen: `${BASE}/gebrauchtmaschinen.png`,
  sonstiges: `${BASE}/sonstiges.png`,
};

// Bild, wenn zur Kategorie keins hinterlegt ist.
export const DEFAULT_IMAGE = `${BASE}/default.png`;

/**
 * Liest die Kategorie einer Anzeige aus publicData.
 *
 * @param {Object} listing Listing-Entity
 * @returns {string|null} Kategorie-ID oder null
 */
export const getListingCategory = listing => {
  const publicData = listing?.attributes?.publicData || {};
  for (const key of CATEGORY_KEYS) {
    const value = publicData[key];
    if (typeof value === 'string' && value.length > 0) {
      return value;
    }
    if (Array.isArray(value) && typeof value[0] === 'string') {
      return value[0];
    }
  }
  return null;
};

/**
 * Liefert das Standardbild für eine Anzeige ohne eigenes Foto.
 *
 * @param {Object} listing Listing-Entity
 * @returns {string} Pfad zum Bild
 */
export const getCategoryImage = listing => {
  const category = getListingCategory(listing);
  return (category && CATEGORY_IMAGES[category]) || DEFAULT_IMAGE;
};
